import ecommerce from '../../../../../ecommerce/ecwid/custom';
import dom from '../../../../../wrapper/DomWrapper';
import WidgetWrapper from '../../../../../wrapper/WidgetWrapper';

class StorefrontPage extends WidgetWrapper {
  init = async () => {
    const elStorefront = dom.getElement('.storefront-wrapper');
    const section = elStorefront?.closest('.s-section');

    if (section) {
      section.removeAttribute('style');
      dom.removeElement(dom.getElement('.section_bg', section));
    }

    dom.addClass(elStorefront, 'spinner');
    dom.updateStyle(elStorefront, { minHeight: `${Math.round(dom.window.innerHeight / 2)}px` });
    dom.window.xProductBrowser('id=storefront-page');
    await ecommerce.provider.initStorefront(elStorefront);
    dom.removeClass(elStorefront, 'spinner');
  };
}

export default StorefrontPage;
